import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";

import { ch3_p08 } from "../../../layouts/ch3_p08/ch3_p08"

export class Chapter3Page8 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly holly = this.addChild(new SceneSprite());
	readonly hollyGuitar = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch3_p08/")); // HACK
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch3_p08/")); // HACK
	readonly linesLeft = this.addChild(new SceneSprite());
	readonly linesRight = this.addChild(new SceneSprite());

	dontScaleUp = true;

	public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
		ch3_p08.call(this);

		// interactivity
		this.holly.visible = false;
		this.hollyGuitar.visible = true;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: () => void) {
		super.animateIn(pOnComplete);
	}

	public animateOut(pOnComplete: () => void) {
		super.animateOut(pOnComplete);
		HLF.Application.instance.audio.stop("HH_Ch3_Loop_LAYER1", HLF.AudioCategory.BGM);
		HLF.Application.instance.audio.stop("HH_Ch3_Loop_Bassoon_LAYER_2", HLF.AudioCategory.BGM);
		HLF.Application.instance.audio.stop("HH_Ch3_Loop_AC_GTR_LAYER_3", HLF.AudioCategory.BGM);
		HLF.Application.instance.audio.stop("HH_Ch3_Loop_PERC_LAYER_4", HLF.AudioCategory.BGM);
		HLF.Application.instance.audio.stop("HH_Ch3_Loop_MEL_PERC_LAYER_5", HLF.AudioCategory.BGM);
		HLF.Application.instance.audio.stop("HH_Ch3_Loop_WW_LAYER_6", HLF.AudioCategory.BGM);
	}

	protected onAnimateInComplete() {
		new TimelineLite()
			.call(() => {
				this.hollyGuitar.FadeOut();
				this.holly.FadeIn();
			}, undefined, undefined, "+=1.5")
			.call(() => {
				super.onAnimateInComplete();
			}, undefined, undefined, "+=1.5")
			.call(() => {
				this.gotoNextState({ transition: "fade" });
			}, undefined, undefined, "+=1.5")
	}
}